import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { AiTutorSprite } from '@/shared/components/Chatbot/AiTutorSprite';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { AiTutorInstallModal } from '../components/AiTutorInstallModal';
import { BuildProFeatureCoachmarkAnchor } from '../components/BuildProFeatureCoachmark';
import { FeatureUpsellModal } from '../components/FeatureUpsellModal';
import { useBuildFormContext } from '../form/schema';
import { SettingChangeButton } from './SettingChangeButton';
import { ToggleOptionContainer } from './ToggleOptionContainer';
export const AiTutorSetting = () => {
  const {
    t
  } = useTranslation(['build']);
  const {
    userPlanManager
  } = useUserPlanManager();
  const upsellingGuard = useUpsellingGuard();
  const {
    isMobile
  } = useViewport();
  const {
    watch,
    setValue
  } = useBuildFormContext();
  const aiTutorEnabled = watch('aiTutorEnabled');
  const selectedAiTutor = watch('aiTutor');
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_TUTOR');
  return <div className="flex flex-col gap-sm" data-sentry-component="AiTutorSetting" data-sentry-source-file="AiTutorSetting.tsx">
      <ToggleOptionContainer optionIcon={<AiTutorSprite size={20} />} optionTitle={t('build:aiTutor.title')} optionDescription={t('build:aiTutor.description')} isOn={aiTutorEnabled} onToggle={() => upsellingGuard(() => {
      if (aiTutorEnabled) {
        setValue('aiTutorEnabled', false);
      } else {
        if (selectedAiTutor) {
          setValue('aiTutorEnabled', true);
          return;
        }
        if (!selectedAiTutor) {
          logger.track('click_build_ai_tutor_settings', {
            action: 'add'
          });
          overlay.open(({
            unmount
          }) => <AiTutorInstallModal onConfirmAiTutor={aiTutor => {
            setValue('aiTutorEnabled', true);
            setValue('aiTutor', {
              id: aiTutor.id,
              name: aiTutor.name,
              avatarSrc: aiTutor.previewAvatarSrc,
              introduction: aiTutor.introduction
            });
            overlay.unmountAll();
          }} onClose={unmount} />);
        }
      }
    }, {
      feature: 'AI_TUTOR',
      from: 'aiTutor',
      onGuard: () => {
        logger.track('click_build_ai_tutor_settings', {
          action: 'add'
        });
        overlay.open(({
          unmount
        }) => isMobile ? <FeatureUpsellModal feature="AI_TUTOR" onClose={unmount} /> : <AiTutorInstallModal mode="upsell" onClose={unmount} />);
      }
    })} planType={featurePlanType} isBadgeVisible={true} renderToggle={toggle => <BuildProFeatureCoachmarkAnchor feature="AI_TUTOR">
            {toggle}
          </BuildProFeatureCoachmarkAnchor>} data-sentry-element="ToggleOptionContainer" data-sentry-source-file="AiTutorSetting.tsx" />

      {aiTutorEnabled && selectedAiTutor && <div className="flex min-h-[82px] items-center gap-sm rounded-md border border-alternative px-lg py-md">
          <img src={selectedAiTutor.avatarSrc} alt={selectedAiTutor.name} className="size-xl shrink-0 rounded-full" width={32} height={32} />
          <div className="flex min-w-0 flex-1 flex-col gap-3xs">
            <h4 className="text-body-md-bold text-default">
              {selectedAiTutor.name}
            </h4>
            <p className="text-body-sm-medium text-alternative">
              {selectedAiTutor.introduction}
            </p>
          </div>
          <SettingChangeButton onClick={() => {
        logger.track('click_build_ai_tutor_settings', {
          action: 'edit'
        });
        overlay.open(({
          unmount
        }) => <AiTutorInstallModal initialSelectedAiTutorId={selectedAiTutor.id} onConfirmAiTutor={aiTutor => {
          setValue('aiTutor', {
            id: aiTutor.id,
            name: aiTutor.name,
            avatarSrc: aiTutor.previewAvatarSrc,
            introduction: aiTutor.introduction
          });
          overlay.unmountAll();
        }} onClose={unmount} />);
      }} />
        </div>}
    </div>;
};